module.exports = __webpack_public_path__ + "img/21.bfc47a1a.jpg";